import { gql } from "@apollo/client"

export const LEAVE_ORGANIZATION = gql`
  mutation leaveOrganization {
    leaveOrganization {
      ok
    }
  }
`
